import { z } from 'zod';
// ---------- A4 Pendientes de facturar y previsión ----------
export const IssuerViaSchema = z.enum(['EXPLICIT', 'CASE', 'LAWYER', 'CLIENT', 'DEFAULT']);
/** De dónde sale el emisor con el que se factura (orden de prioridad, de mayor a menor). */
export const IssuerViaLabel = {
    EXPLICIT: 'indicado a mano',
    CASE: 'emisor del expediente',
    LAWYER: 'emisor del abogado responsable',
    CLIENT: 'emisor del cliente',
    DEFAULT: 'emisor por defecto del bufete',
};
export const ResolvedBillingSchema = z.object({
    issuer: z.object({ id: z.string(), name: z.string(), nif: z.string() }),
    series: z.object({ id: z.string(), prefix: z.string(), name: z.string() }),
    via: IssuerViaSchema,
});
export const PendingKindSchema = z.enum(['RECURRING', 'MILESTONE', 'QUOTE', 'TIME']);
export const PendingKindLabel = {
    RECURRING: 'Cuota de iguala',
    MILESTONE: 'Hito de pago',
    QUOTE: 'Presupuesto aceptado',
    TIME: 'Tiempos sin facturar',
};
export const PendingBillingItemSchema = z.object({
    kind: PendingKindSchema,
    /** Clave estable para la lista (kind + id + fecha). */
    key: z.string(),
    /** Id del hito, la iguala, el presupuesto o (tiempos) el expediente. */
    sourceId: z.string(),
    label: z.string(),
    clientId: z.string(),
    clientName: z.string(),
    caseId: z.string().nullable(),
    caseCode: z.string().nullable(),
    dueDate: z.string(),
    /** Días de retraso respecto a hoy (0 si aún no ha vencido). */
    daysLate: z.number().int(),
    /** Aún no vence: vence este mes o el siguiente. */
    upcoming: z.boolean(),
    daysUntil: z.number().int(),
    baseCents: z.number().int(),
    /** Null en los tiempos: su IVA depende de cómo se facture. */
    vatCents: z.number().int().nullable(),
    totalCents: z.number().int().nullable(),
    /** Se puede crear la factura ahora (en una iguala atrasada, solo la cuota más antigua). */
    canEmit: z.boolean(),
    /** Emisor con el que saldría la factura; null si no se puede determinar (ver `issuerProblem`). */
    issuerName: z.string().nullable(),
    issuerNif: z.string().nullable(),
    issuerVia: IssuerViaSchema.nullable(),
    issuerProblem: z.string().nullable(),
});
export const PendingBillingResponseSchema = z.object({
    items: z.array(PendingBillingItemSchema),
    /** Lo que ya toca facturar (sin lo que solo vence este mes o el siguiente). */
    dueCount: z.number().int(),
    dueBaseCents: z.number().int(),
    upcomingCount: z.number().int(),
    upcomingBaseCents: z.number().int(),
});
export const ForecastMonthSchema = z.object({
    /** AAAA-MM */
    month: z.string(),
    /** Base imponible prevista (hitos, cuotas de iguala y presupuestos aceptados). */
    projectedCents: z.number().int(),
    projectedCount: z.number().int(),
    /** Base ya facturada ese mes (misma regla que «facturado» de la ficha). */
    emittedCents: z.number().int(),
    /** Cobrado ese mes (IVA incluido). */
    collectedCents: z.number().int(),
});
export const BillingForecastResponseSchema = z.object({
    months: z.array(ForecastMonthSchema),
    totalProjectedCents: z.number().int(),
});
//# sourceMappingURL=billing-pending.js.map